import { createRouter, createWebHistory } from 'vue-router'
import Catalogo from '../views/pedidos.vue'
import LoginPage from '../views/login.vue'
import ErrorPage from '../views/error-page.vue'
import OlvideMiContra from '../views/OlvideMiContra.vue'
import Terminos from '../views/terminos.vue'
import Habilitacion from '../views/Habilitacion.vue'
import Carrito from '../views/carrito.vue'
import Pedido from '../views/confirmarPedido.vue'
import PageNotFound from '../views/PageNotFound.vue'
import AdminLayout from '../views/Admin.vue'
import AdminHome from '../views/AdminHome.vue'
import AdminUsuarios from '../views/AdminUsuarios.vue'
import AdminContactos from '../views/AdminContactos.vue'
import AdminPedidos from '../views/AdminPedidos.vue'
import AdminProductos from '../views/AdminProductos.vue'
import AdminProductosCategorias from '../views/AdminProductosCategorias.vue'
import AdminConfiguracion from '../views/AdminConfiguracion.vue'
import PedidosUsuarios from '../views/PedidosUsuarios.vue'
import Mantenimiento from '../views/Mantenimiento.vue'
import Perfil from '../views/Perfil.vue'
import ImportarPedido from '../views/ImportarPedidos.vue'
import CatalogoConPrecio from '../views/CatalogoConPrecio.vue'
import CatalogoSinPrecio from '../views/CatalogoSinPrecio.vue'
import PedidoConfirmado from '../views/PedidoCreado.vue'
import MisPedidos from '../views/MisPedidos.vue'
import Catalogos from '../views/Catalogos.vue'
import HomeView from '@/views/HomeView.vue'
import Consulta from '@/views/Consulta.vue'
import Certificados from '@/views/Certificados.vue'
import AdminCertificados from '@/views/AdminCertificados.vue'
import Redirect from '@/views/Redirect.vue'

const routes = [
  {
    path: '/',
    component: HomeView
  },
  {
    path: '/certificados',
    name: 'certificados',
    component: Certificados
  },
  {
    path: '/inventario/A5T5dH56TDV4f',
    name: 'inventario con precio',
    component: CatalogoConPrecio
  },
  {
    path: '/inventario/j9PqXr3yZs7Vw2',
    name: 'inventario sin precio',
    component: CatalogoSinPrecio
  },
  {
    path: '/catalogo',
    name: 'catalogo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    component: Catalogo
  },
  {
    path: '/consulta',
    name: 'consulta',
    component: Consulta
  },
  {
    path: '/Catalogos',
    name: 'catalogos',
    component: Catalogos
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/olvide-mi-contrasena',
    name: 'olvide-mi-contra',
    component: OlvideMiContra
  },
  {
    path: '/mantenimiento',
    name: 'mantenimiento',
    component: Mantenimiento
  },
  {
    path: '/terminos',
    name: 'terminos',
    component: Terminos
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: Perfil
  },
  {
    path: '/mis-pedidos',
    name: 'misPedidos',
    component: MisPedidos
  },
  {
    path: '/esperando-habilitacion',
    name: 'habilitacion',
    component: Habilitacion
  },
  {
    path: '/pedido-confirmado',
    name: 'pedidoConfirmado',
    component: PedidoConfirmado
  },
  {
    path: '/carrito',
    name: 'carrito',
    component: Carrito
  },
  {
    path: '/importar-pedido',
    name: 'importarPedido',
    component: ImportarPedido
  },
  {
    path: '/confirmar-pedido/:idcli?',
    name: 'pedido',
    component: Pedido
  },
  {
    path: '/error-page',
    name: 'error-page',
    component: ErrorPage
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: Redirect
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      { path: '', component: AdminHome },
      { path: 'home', component: AdminHome },
      { path: 'usuarios', component: AdminUsuarios },
      { path: 'usuarios/pedidos/:user', component: PedidosUsuarios},
      { path: 'contactos', component: AdminContactos },
      { path: 'pedidos', component: AdminPedidos },
      { path: 'productos', component: AdminProductos },
      { path: 'productos/categorias', component: AdminProductosCategorias },
      { path: 'certificados', component: AdminCertificados },
      { path: 'configuracion', component: AdminConfiguracion },
      // { path: 'child2', component: Child2 },
    ],
  },
  { 
    path: '/:catchAll(.*)',
    component: PageNotFound 
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes  
})

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/') {
      window.location.href = 'https://www.charko.com.ar';
  }
  const publicPages = ['/login', '/olvide-mi-contrasena', '/terminos', '/esperando-habilitacion', '/mantenimiento', '/certificados', '/redirect']
  var authRequired = !publicPages.includes(to.path)
  if (authRequired) {
    authRequired = !to.path.startsWith('/inventario')
  }
  const loggedIn = localStorage.getItem('user')

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next(`/login`)
  } else {
    // Scroll to the top of the page on route change
    window.scrollTo(0, 0);
    next();

  }
});

export default router
